<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" width="850" :loading="loading" :mask-closable="false" :class-name="z100000">
      <h3 slot="header" class="modal-header">回访跟进</h3>
      <Form :model="formData" :label-width="100" ref="formData">
        <Row>
          <Col :span="formData.currentStatus===99?6:10">
            <FormItem label="当前状态" prop="currentStatus">
              <Select  v-model="formData.currentStatus">
                <Option  value="">请选择</Option>
                <Option v-for="(item,index) in currentStatusList" :key="'s4'+index" :value="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="4" v-if="formData.currentStatus == 99">
							<Input  placeholder="请填写当前状态" v-model="formData.currentStatusMsg" ></Input>
						</Col>
          <Col span="12">
            <FormItem label="工作地点" prop="workAddressArr">
              <location ref="workaddress" :id="'back1'"></location>

              <!--              <Cascader :data="regionList" trigger="hover" v-model="formData.workAddressArr"></Cascader>-->
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="10">
							<FormItem label="机构名称" prop="originalName">
								<Input  placeholder="请填写机构名称" v-model="formData.originalName" ></Input>
							</FormItem>
						</Col>
						<Col span="10">
							<FormItem label="薪资范围" prop="salaryRange">
								<Select style="width:165px;margin-right:5px" v-model="formData.salaryRange" class="item-width">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in salaryRangeList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select><span>元/月</span>
							</FormItem>
						</Col>
        </Row>
        <Row>
						<Col :span="formData.channel==99?6:10">
							<FormItem label="获知自如寓渠道" prop="channel">
								<Select v-model="formData.channel">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in channelList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select>
							</FormItem>
						</Col>
						<Col span="4" v-if="formData.channel == 99">
							<Input placeholder="请填写获知渠道" v-model="formData.channelMsg" ></Input>
						</Col>
						<Col :span="formData.impression==99?6:10">
							<FormItem label="自如寓印象" prop="impression">
								<Select v-model="formData.impression">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in impressionList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select>
							</FormItem>
						</Col>
						<Col span="4" v-if="formData.impression==99">
							<Input placeholder="请填写对自如寓的印象" v-model="formData.impressionMsg" ></Input>
						</Col>
					</Row>
			</Form>
      <div>
        <Input type="textarea" :rows="4" :maxlength="150"  placeholder="请录入回访内容,不超过150字" v-model="remark"/>
      </div>
      <Br/>
      <div style="display: flex;flex-wrap: wrap">
        <template v-for="(item,index) in imgList ">
          <div class="fileItem">
            <div style="margin-bottom: 10px;">
              <img class="file-img" :src="item" alt="">
              <a href="javascript:;" style="vertical-align: bottom" @click="deleteItem(item,index)">删除</a>
            </div>
          </div>
        </template>
        <div class="fileItem" v-if="imgList.length<=3">
          <Upload class="upload"
                  :action="baseUrl+'/file/uploadFile'"
                  :on-success="handleSuccess"
                  :headers="{'Access-Token':token}"
                  :show-upload-list="false"
                  :on-error="handleError"
                  :format="['jpg','jpeg','png']"
                  :on-format-error="formatError"

          >
            <Icon type="ios-plus-empty" size="30" style="vertical-align: middle"></Icon>
          </Upload>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";
  import {handleVisit} from "../../../../api/workBench";
  import {getBusinessEnums,getAreaRegionByProjectFid,getCustomerPortrait} from '../../../../api/business'

  import Location from 'components/Location/index'

  export default {
    name: "HandleModal",
    components:{
      Location
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      visitFid: {
        type: String,
        default: ''
      },
      uid: {
        type: String,
        default: ''
      },

    },
    watch: {
      n() {
        this.$refs['workaddress'] &&  this.$refs['workaddress'].resetData()

        this.remark=''
        this.imgList=[]
        this.isShow = true
        this.getDetail(this.uid)
        this.getLists();
        this.getRegion(this.visitFid)
        this.formData={}
			  // this.formData.workAddressArr = []




      },

    },
    data() {
      return {
        formData:{},
        isShow: false,
        imgList: [],
        remark:'',
        loading: true,
        token: '',
        baseUrl: '',
        z100000: 'z100000',
        visitEntity:{
            fid:'',
            remark:'',
            img1:'',
            img2:'',
            img3:'',
            img4:''
        },
        currentStatusList:[],
        regionList:[],
        customerEduList:[],
        intentionAreaList:[],
        salaryRangeList:[],
        currentCheckinStatusList:[],
        channelList:[],
        houseTypeList:[],
        commutingModeList:[],
        impressionList:[],
        liveNumberList:[],
        intentionLevelList:[],
      }
    },
    methods: {
      getDetail(uid){
        console.log('===')
        console.log(uid)
        if(!uid){
          return
        }
        //回显
        getCustomerPortrait({uid:uid})
        .then(res=>{
          if(!res.data){
            return

          }
          this.formData = res.data;
				  this.formData.workAddressArr = [this.formData.workAddressCity,this.formData.workAddressArea,this.formData.workAddress];

				  let data=res.data
          this.$refs['workaddress']  &&  this.$refs['workaddress'].setData(
            {
              cityCode:data['workAddressCity']   ,
              regionCode:data['workAddressArea'],
              address: data['workAddressDesc'],
              lon:data['workAddressLon'],
              lat:data['workAddressLat'],
            }
          )
        }).catch(error=>{})
      },
      getRegion(fid){
        getAreaRegionByProjectFid({projectFid:fid}).then( res=>{
          this.regionList = res.data;
        })
      },
      getLists(){
        getBusinessEnums().then( res=>{
          this.salaryRangeList = res.data.salaryRange;
          this.intentionAreaList = res.data.intentionArea;
          this.customerEduList = res.data.customerEdu;
          this.currentStatusList = res.data.currentStatus;
          this.currentCheckinStatusList = res.data.currentCheckinStatus;
          this.channelList = res.data.channel;
          this.houseTypeList = res.data.houseType;
          this.commutingModeList = res.data.commutingMode;
          this.impressionList = res.data.impression;
          this.intentionLevelList = res.data.intentionLevel;
        })
        .catch(err=>{
          console.log(err)
        })
      },
      formatError(){
        this.$Message.info('请上传图片类型文件')
      },
      handleError() {
      },
      handleSuccess(res, file) {
        this.imgList.push(res.data.url)
      },
      deleteItem(item, index) {
        this.imgList.splice(index, 1)
      },
      ok() {
        if(this.formData.currentStatus == 99&&!this.formData.currentStatusMsg){
						this.$Message.info('请输入当前状态')
						this.changeLoading();
						return false
					}
					if(this.formData.currentStatus!=99){
						this.formData.currentStatusMsg = ''
					}
					if(this.formData.channel == 99&&!this.formData.channelMsg){
						this.$Message.info('请输入获知自如寓渠道')
						this.changeLoading();
						return false
					}
					if(this.formData.channel!=99){
						this.formData.channelMsg = ''
					}
					if(this.formData.impression == 99&&!this.formData.impressionMsg){
						this.$Message.info('请输入自如寓印象')
						this.changeLoading();
						return false
					}
					if(this.formData.impression!=99){
						this.formData.impressionMsg = ''
					}
        if(this.formData.workAddressArr[0]){
						this.formData.workAddressCity = this.formData.workAddressArr[0]
					}
					if(this.formData.workAddressArr[1]){
						this.formData.workAddressArea = this.formData.workAddressArr[1]
						this.formData.workAddress = ''
					}
					if(this.formData.workAddressArr[2]){
						this.formData.workAddress = this.formData.workAddressArr[2]
					}
        for (var i = 0; i < this.imgList.length; i++) {
          switch (i) {
            case 0:
                this.visitEntity.img1 = this.imgList[i];
                break;
            case 1:
              this.visitEntity.img2 = this.imgList[i];
              break;
            case 2:
              this.visitEntity.img3 = this.imgList[i];
              break;
            case 3:
              this.visitEntity.img4 = this.imgList[i];
              break;
            default:
              this.visitEntity.img1 = null;
              this.visitEntity.img2= null;
              this.visitEntity.img3 = null;
              this.visitEntity.img4 = null;
              break;
          }
        }
        if((this.imgList==null||this.imgList.length==0)||(this.remark==null||this.remark=='')) {
          this.$Message.error('请录入回访内容或图片');
          this.changeLoading();
          return false
        }
        this.visitEntity.remark = this.remark;
        this.visitEntity.fid  = this.visitFid;
        this.visitEntity = Object.assign(this.visitEntity,this.formData)
        this.visitEntity.customerUid = this.uid;

        //地点调整
        let data={}
        let workdata=this.$refs['workaddress'].data
        data['workAddressCity']=workdata.cityCode
        data['workAddressArea']=workdata.regionCode
        data['workAddressDesc']=workdata.address
        data['workAddressLon'] = workdata.lng
        data['workAddressLat'] = workdata.lat


        handleVisit({...this.visitEntity,...data}).then(res => {
          this.$Message.success('保存成功！')
          this.isShow = false
          this.$emit('refresh')
        }).catch( () => {
          this.changeLoading()
          return
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }

  }
</script>

<style scoped>
  .upload {
    display: inline-block;
    width: 60px;
    height: 60px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 80px;
  }

  .fileItem {
    margin-right: 20px;
  }

  .content-right {
    /*border: 1px solid black;*/
    overflow: hidden;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;

  }

  .file-img {
    width: 150px;
    height: 85px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }

  .input-width {
    width: 150px;
    margin-bottom: 10px;
  }


</style>
